import React, { useRef, useMemo, useState, useEffect } from "react";
import { CheckPicker, Form, FormControl } from "rsuite";

import { debounce } from "utils";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import FieldDataRange from "components/Form/FieldDataRange";
import { buildDateFilterFormValue, normalizeDateRange } from "components/Payments";


export default ({ filters, onChangeFilters, accounts }) => {
    const [changedFormValue, changeFormData] = useState(() => buildDateFilterFormValue(filters));
    const onChangeFiltersRef = useRef(onChangeFilters);

    const debouncedOnChangeFilters = useMemo(() => debounce((value) => {
        onChangeFiltersRef.current(value);
    }, 400), []);

    useEffect(() => {
        onChangeFiltersRef.current = onChangeFilters;
    }, [onChangeFilters]);

    useEffect(() => {
        changeFormData(buildDateFilterFormValue(filters));
    }, [filters]);

    useEffect(() => {
        return () => {
            debouncedOnChangeFilters.cancel();
        };
    }, [debouncedOnChangeFilters]);

    const filteredAccounts = accounts.filter(item => {
        return item.is_managed;
    });

    const formattedAccounts = filteredAccounts.map((account) => {
        return {
            ...account,
            name: `${account.name} / ${account.service}`
        };
    });

    const handleChange = (value) => {
        const normalized = normalizeDateRange(value?.start_end_date);

        let formData = value;

        if (!normalized) {
            changeFormData(formData);
            debouncedOnChangeFilters(formData);
            return;
        }

        const [startDate, endDate] = normalized;
        formData = {
            ...value,
            start_end_date: [startDate, endDate],
            start_date: startDate,
            end_date: endDate,
        };

        changeFormData(formData);
        debouncedOnChangeFilters(formData);
    };


    return (
        <Form formValue={changedFormValue} onChange={handleChange}>
            <FlexGrid align="middle">
                <FlexGridItem>
                    <FormControl
                        accepter={CheckPicker}
                        sticky
                        name="account_id_list"
                        data={formattedAccounts}
                        valueKey="id"
                        labelKey="name"
                        placeholder="Accounts"
                        style={{ width: 290 }}
                        menuStyle={{ width: 360 }}
                    />
                </FlexGridItem>
                <FlexGridItem>Date from</FlexGridItem>
                <FlexGridItem>
                    <FieldDataRange name="start_end_date" />
                </FlexGridItem>
            </FlexGrid>
        </Form>
    );
};